var render = function (_h,_vm) {var _c=_vm._c;return (typeof _vm.props.for === 'undefined' || (!_vm.props.for || !_vm.props.for.length))?_c('div',{class:['Empty', _vm.data.class, _vm.data.staticClass]},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }